import React from 'react';
import styled from 'styled-components';
import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { TopNav } from '../shared/components/navigation/TopNav';
import { PaperContainer } from '../shared/components/containers/PaperContainer';

interface OwnProps {
}

const PageWrapper = styled.div`
  padding: 20px;
`;

const PageHeader = styled.h1`
  font-size: 1.4em;
  margin-bottom: 15px;
`;

const StyledPaperContainer = styled(PaperContainer)`
  max-width: 400px;
  padding: 20px 30px;
`;

const LanguageSelect = styled(Form.Select)`
  width: 100%;
`;

const SettingsPage = (props: OwnProps) => {
  const {} = props;
  const { t, i18n } = useTranslation();

  return (
    <div>
      <TopNav/>
      <PageWrapper>
        <PageHeader>{t('settingsPage.title')}</PageHeader>

        <StyledPaperContainer>
          <Form.Label htmlFor="settings-language">{t('settingsPage.language.label')}</Form.Label>
          <LanguageSelect
            id="settings-language"
            value={i18n.resolvedLanguage}
            onChange={(e) => i18n.changeLanguage(e.target.value)}
          >
            <option value="en">{t('settingsPage.language.english')}</option>
            <option value="da">{t('settingsPage.language.danish')}</option>
          </LanguageSelect>
        </StyledPaperContainer>
      </PageWrapper>
    </div>
  );
};

export {
  SettingsPage,
};
